// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3FbZi","banner":"Footer_banner__1rbX5"};